import { Injectable, InjectionToken } from '@angular/core';
import { IDiagnosticsService, IDiagnosticsConfig } from './interfaces';

/**
 * A defaut service for collecting diagnostic information.
 * Logs the information to console, when logLevel is set to DEBUG, WARNING, or ERROR.
 * Swallows the messages if no logLevel setting is provided.
 * The service instance is created by corresponding factory for each component, which
 * allows capturing component-specific information.
 */
@Injectable({
  providedIn: 'root'
})
export class DefaultDiagnosticsService implements IDiagnosticsService {
  private _scope: string;

  constructor(scope: string, private config: IDiagnosticsConfig) {
    if (!this.config.logLevel) {
      console.log(
        'DefaultDiagnosticsService: no log level provided. Diagnostic logging is turned off.' +
        ' Supported log level values: DEBUG, WARNING, ERROR.');
    }

    if (this.config.logLevel !== 'DEBUG' &&
      this.config.logLevel !== 'WARNING' &&
      this.config.logLevel !== 'ERROR') {
      console.log(
        `DefaultDiagnosticsService:ERROR: Not supported logging level:` +
        ` ${this.config.logLevel}. Diagnostic logging will be turned off. ` +
        `Supported values: DEBUG, WARNING, ERROR.`);
    }

    if (scope) {
      this._scope = scope;
    } else {
      this._scope = this.constructor.name;
    }
  }

  public getScope(): string {
    return this._scope;
  }

  public logDebug(message: string) {
    if (this.config.logLevel === 'DEBUG') {
      this.log(message, 'DEBUG');
    }
  }

  public logWarning(message: string) {
    if (this.config.logLevel === 'DEBUG' || this.config.logLevel === 'WARNING') {
      this.log(message, 'WARNING');
    }
  }

  public logError(message: string) {
    if (this.config.logLevel === 'DEBUG' ||
      this.config.logLevel === 'WARNING' ||
      this.config.logLevel === 'ERROR') {
      this.log(message, 'ERROR');
    }
  }

  private log(message: string, level: string) {
    const scope = (this._scope) ? this._scope : this.constructor.name;
    console.log(`${scope}:${level}: ${message}`);
  }
}
